// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__q9Wii","LabelText":"Label_LabelText__BOQZF"};